/**
 * The price book's optimistic-concurrency refusal.
 *
 * `PATCH /catalogue/items/{id}` with a stale `expected_rev` answers 409 with
 * `{ detail: { detail: "<words>", current: <item> } }`. The item that is there
 * now rides along so the form can rebase onto it instead of making the person
 * reload and retype.
 */

import { ApiError } from "./api";
import type { CatalogueItemOut } from "./types";

export type ItemConflict = { message: string; current: CatalogueItemOut };

export function itemConflict(err: unknown): ItemConflict | null {
  if (!(err instanceof ApiError) || err.status !== 409) return null;
  const outer = err.detail;
  if (!outer || typeof outer !== "object") return null;
  const inner = (outer as { detail?: unknown }).detail;
  if (!inner || typeof inner !== "object") return null;
  const { detail, current } = inner as { detail?: unknown; current?: unknown };
  if (!current || typeof current !== "object") return null;
  return {
    message: typeof detail === "string" && detail ? detail : err.message,
    current: current as CatalogueItemOut,
  };
}
